module.exports = __webpack_public_path__ + "f96f5c5a0b548a02faf7d47a5609d872.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/pt.png
// module id = 1051
// module chunks = 0